import React, { useState, useEffect, useRef } from "react";
import { NavLink, Outlet ,useLocation,Link} from "react-router-dom";
import { getProjects, getCSCs } from "../../api";
import useDebouncedValue from "../../hooks/useDebouncedValue"; // you already created this earlier
import SidebarUserBadge from "./SidebarUserBadge";
function dispatchSearch({ type, query }) {
    window.dispatchEvent(new CustomEvent("ksk:search", { detail: { type, query } }));
  }

  function getDistrictNamesFromAccount(account) {
    // If your account.centers are objects like [{id, name}], use names directly:
    if (Array.isArray(account?.centers) && account.centers.length > 0) {
      const sample = account.centers[0];
      if (sample && typeof sample === "object" && ("name" in sample)) {
        return account.centers.map(c => c.name).filter(Boolean);
      }
    }
    // Fallback if centers are just ids; show count
    if (Array.isArray(account?.centers) && account.centers.length > 0) {
      return [`${account.centers.length} district(s)`];
    }
    return [];
  }

export default function SidebarLayout({ onLogout }) {
  const [open, setOpen] = useState(false);
  const drawerRef = useRef(null);
  const [searchType, setSearchType] = useState("project"); // "project" | "csc"
  const [searchQuery, setSearchQuery] = useState("");
  // Search UI state
  const [account] = useState(() => {
        try {
          const raw = localStorage.getItem("kskfield_user");
        return raw ? JSON.parse(raw) : null;
        } catch {
          return null;
        }
      });
  const createUserPath =
      account?.role === "ADMIN"
          ? "/dashboard/users/new-center-head"
          : account?.role === "DIVISIONAL_MANAGER"
          ? "/dashboard/users/new-drive-user"
          : null;
const [results, setResults] = useState([]);
const [hi, setHi] = useState(-1);
const [loading, setLoading] = useState(false);
const districts = getDistrictNamesFromAccount(account);
const titleText = districts.length ? `Allowed districts: ${districts.join(", ")}` : "No districts assigned";

// Lazy datasets (cached)
const [projectsData, setProjectsData] = useState(null);
const [cscData, setCscData] = useState(null);
const location = useLocation();
const hideHeader =location.pathname.startsWith("/dashboard/drive");
// Debounce the input
const dq = useDebouncedValue(searchQuery, 200);
// Load datasets on first need
useEffect(() => {
    // only fetch when there's a query
    if (!dq.trim()) {
      setResults([]);
      setHi(-1);
      return;
    }
  
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        if (searchType === "project" && !projectsData) {
          const res = await getProjects();
          const raw = res?.data?.data || res?.data || res || [];
          const arr = Array.isArray(raw) ? raw : raw.projects || [];
          // normalize lat/lon to numbers
          setProjectsData(
            arr.map((p) => ({
              ...p,
              Latitude:
                typeof p.Latitude === "string" ? parseFloat(p.Latitude) : p.Latitude,
              Longitude:
                typeof p.Longitude === "string" ? parseFloat(p.Longitude) : p.Longitude,
            }))
          );
        }
        if (searchType === "csc" && !cscData) {
          const res = await getCSCs();
          const arr = res?.data || res || [];
          setCscData(
            arr.map((c) => ({
              ...c,
              Latitude:
                typeof c.Latitude === "string" ? parseFloat(c.Latitude) : c.Latitude,
              Longitude:
                typeof c.Longitude === "string" ? parseFloat(c.Longitude) : c.Longitude,
            }))
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
  
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dq, searchType]);
  useEffect(() => {
    const q = dq.trim().toLowerCase();
    if (!q) {
      setResults([]);
      setHi(-1);
      return;
    }
  
    const src = searchType === "project" ? projectsData : cscData;
    if (!src) {
      setResults([]);
      setHi(-1);
      return;
    }
  
    const filtered = src
      .filter(
        (x) =>
          x?.Name &&
          Number.isFinite(x?.Latitude) &&
          Number.isFinite(x?.Longitude) &&
          x.Name.toLowerCase().includes(q)
      )
      .slice(0, 10);
  
    setResults(filtered);
    setHi(filtered.length ? 0 : -1);
  }, [dq, searchType, projectsData, cscData]);
  

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);


  useEffect(() => {
    const onClick = (e) => {
      if (!open) return;
      if (drawerRef.current && !drawerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);
  useEffect(() => {
      const onOpen = () => setOpen(true);
       window.addEventListener("ksk:open-drawer", onOpen);
       return () => window.removeEventListener("ksk:open-drawer", onOpen);
     }, [])
  const Z = { header: 10000, overlay: 9500, drawer: 9600 };
  function selectItem(item) {
    if (!item) return;
    const q = item.Name;
    dispatchSearch({ type: searchType, query: q });
    setSearchQuery("");
    setResults([]);
    setHi(-1);
    setOpen(false);


  }
  
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>

{!hideHeader &&(
      <header
        style={{
          height: 56,
          borderBottom: "1px solid #e5e7eb",
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "0 12px",
          position: "sticky",
          top: 0,
          zIndex: Z.drawer,
          background: "#fff",
        }}
      >
     <button
          aria-label="Open navigation"
          onClick={() => setOpen(true)}
          style={hamburgerButton}
        >
          <span style={hamburgerLine} />
          <span style={hamburgerLine} />
          <span style={hamburgerLine} />
        </button>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12,    flex: 1,  }}>
  <div style={{ fontWeight: 800, fontSize: 20, color: "#0f172a" }}>KSK Field</div>
  <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 12 }}>
{/* RIGHT: Create User (left) + user avatar/name (right) */}
</div>

<div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 12 }}>
{(account?.role === "ADMIN" || account?.role === "DIVISIONAL_MANAGER") && (
  <Link
    to="/dashboard/users/manage"
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      padding: "8px 12px",
      borderRadius: 8,
      border: "1px solid #e5e7eb",
      textDecoration: "none",
      color: "#0f172a",
      fontWeight: 600,
      background: "#ffffff",
    }}
    title="Manage Users"
  >
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 6h12M6 12h12M6 18h12" stroke="#0f172a" strokeWidth="2" fill="none" strokeLinecap="round"/>
    </svg>
    <span>Manage Users</span>
  </Link>
)}
  {createUserPath && (
    <Link
      to={createUserPath}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        padding: "8px 12px",
        borderRadius: 8,
        border: "1px solid #e5e7eb",
        textDecoration: "none",
        color: "#0f172a",
        fontWeight: 600,
        background: "#f8fafc",
      }}
      title={account?.role === "ADMIN" ? "Create Center Head" : "Create Drive User"}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 5v14M5 12h14" stroke="#0f172a" strokeWidth="2" fill="none" strokeLinecap="round"/>
      </svg>
      <span>Create User</span>
    </Link>
  )}

  {/* User icon + username */}
  <SidebarUserBadge />

</div>
</div>

      </header>)}


      {open && <div style={overlay} />}
      <aside
        ref={drawerRef}
        role="navigation"
        aria-label="Main"
        style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: 280,
            background: "#0f172a",
            color: "white",
            padding: 16,
            boxShadow: "0 10px 30px rgba(0,0,0,.2)",
            display: "flex",
            flexDirection: "column",
            gap: 12,
            transition: "transform 240ms ease",
            transform: open ? "translateX(0)" : "translateX(-100%)",
            zIndex: Z.drawer,   // ⬅ ABOVE overlay & map
        }}
      >
       <div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
  }}
>
  <div style={{ fontWeight: 800, fontSize: 20 }}>KSK Field</div>

  <button
    aria-label="Close navigation"
    onClick={() => setOpen(false)}
    style={{
      background: "transparent",
      border: "none",
      color: "#f87171", // bright red
      fontSize: 28,
      cursor: "pointer",
      lineHeight: 1,
      fontWeight: "bold",
    }}
  >
    &minus;
  </button>
</div>

        <nav style={{ display: "grid", gap: 8 }}>
          <NavLink to="/dashboard/map" style={navStyle} onClick={() => setOpen(false)}>
            Map (Projects + CSC)
          </NavLink>

          {(account?.role === "ADMIN" || account?.role === "DIVISIONAL_MANAGER") && (
            <NavLink
              to="/dashboard/trackkaro"
              style={navStyle}
              onClick={() => setOpen(false)}
            >
              Track Karo (Vehicles)
            </NavLink>
          )}

          <NavLink to="/dashboard/saved-iec" style={navStyle} onClick={() => setOpen(false)}>
            View Saved IEC Forms
          </NavLink>

          <NavLink to="/dashboard/drive-history" style={navStyle} onClick={() => setOpen(false)}>
            View Drive Details
          </NavLink>
        </nav>
        <div style={{ marginTop: 12, paddingTop: 12, borderTop: "1px solid #233244" }}>
  <div style={{ fontWeight: 700, marginBottom: 8 }}>Search</div>

  <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
    <button
      onClick={() => { setSearchType("project"); setResults([]); setHi(-1); }}
      style={{
        flex: 1,
        background: searchType === "project" ? "#334155" : "transparent",
        border: "1px solid #334155",
        color: "white",
        padding: "8px 10px",
        borderRadius: 8,
        cursor: "pointer",
        fontWeight: 600,
      }}
    >
      Project
    </button>
    <button
      onClick={() => { setSearchType("csc"); setResults([]); setHi(-1); }}
      style={{
        flex: 1,
        background: searchType === "csc" ? "#334155" : "transparent",
        border: "1px solid #334155",
        color: "white",
        padding: "8px 10px",
        borderRadius: 8,
        cursor: "pointer",
        fontWeight: 600,
      }}
    >
      CSC
    </button>
  </div>

  <div style={{ position: "relative" }}>
    <input
      type="text"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      onKeyDown={(e) => {
        if (!results.length) return;
        if (e.key === "ArrowDown") {
          e.preventDefault();
          setHi((i) => Math.min(i + 1, results.length - 1));
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          setHi((i) => Math.max(i - 1, 0));
        } else if (e.key === "Enter") {
          e.preventDefault();
          selectItem(results[hi]);
        } else if (e.key === "Escape") {
          setResults([]);
          setHi(-1);
        }
      }}
      placeholder={searchType === "project" ? "Search Project..." : "Search CSC..."}
      style={{
        width: "90%",
        padding: "10px 12px",
        borderRadius: 8,
        border: "1px solid #334155",
        background: "#0b1220",
        color: "white",
        outline: "none",
      }}
    />

    {/* Suggestions */}
    {(loading || results.length > 0) && (
      <div
        style={{
          position: "absolute",
          top: "calc(100% + 6px)",
          left: 0,
          right: 0,
          background: "#0b1220",
          border: "1px solid #334155",
          borderRadius: 8,
          maxHeight: 260,
          overflowY: "auto",
          boxShadow: "0 8px 24px rgba(0,0,0,.35)",
          zIndex: 9999,
        }}
      >
        {loading && (
          <div style={{ padding: "10px 12px", color: "#9aa5b1" }}>Searching…</div>
        )}
        {!loading && results.map((item, idx) => (
          <div
            key={item._id || item.CSCID || idx}
            onClick={() => selectItem(item)}
            onMouseEnter={() => setHi(idx)}
            style={{
              padding: "10px 12px",
              cursor: "pointer",
              background: hi === idx ? "#1e293b" : "transparent",
              color: "white",
              display: "flex",
              justifyContent: "space-between",
              gap: 8,
            }}
          >
            <span style={{ fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {item.Name}
            </span>
            <span style={{ color: "#94a3b8", fontSize: 12 }}>
              {searchType === "csc" ? item.District || "" : item.District || ""}
            </span>
          </div>
        ))}
        {!loading && !results.length && dq && (
          <div style={{ padding: "10px 12px", color: "#9aa5b1" }}>No results</div>
        )}
      </div>
    )}
  </div>

  <button
    onClick={() => {
      if (!searchQuery.trim()) return;
      dispatchSearch({ type: searchType, query: searchQuery.trim() });
      setSearchQuery("");
      setResults([]);
      setHi(-1);
      setOpen(false);
      // setOpen(false);
    }}
    style={{
      marginTop: 8,
      width: "100%",
      background: "#0ea5e9",
      color: "#fff",
      border: "none",
      borderRadius: 8,
      padding: "10px 12px",
      cursor: "pointer",
      fontWeight: 700,
    }}
  >
    Search
  </button>
</div>


        <button onClick={onLogout} style={logoutButton}>
          Logout
        </button>
      </aside>

      {/* Page content */}
      <main style={{ flex: 1, padding: hideHeader ? "0" : "12px" }}>
        <Outlet />
      </main>
    </div>
  );
}

const drawerBase = {
  position: "fixed",
  top: 0,
  left: 0,
  height: "100vh",
  width: 280,
  background: "#0f172a",
  color: "white",
  padding: 16,
  zIndex: 40,
  transition: "transform 240ms ease",
  boxShadow: "0 10px 30px rgba(0,0,0,.2)",
  display: "flex",
  flexDirection: "column",
  gap: 12,
};

const overlay = {
    position: "fixed",
    inset: 0,
    background: "rgba(2,6,23,0.45)", // a touch darker, no blur
    zIndex: 9500,
    pointerEvents: "auto",
  };
  

const navStyle = ({ isActive }) => ({
  background: isActive ? "#1e293b" : "transparent",
  color: "white",
  padding: "10px 12px",
  borderRadius: 8,
  textDecoration: "none",
  fontWeight: 600,
  border: "1px solid #334155",
});

const logoutButton = {
    position: "absolute",
    bottom: "40px", 
  width: "90%",
  background: "#ef4444",
  color: "white",
  border: "none",
  borderRadius: 8,
  padding: "10px 12px",
  cursor: "pointer",
  fontWeight: 700,
};

const hamburgerButton = {
  width: 40,
  height: 40,
  borderRadius: 8,
  border: "1px solid #e5e7eb",
  background: "#fff",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
};

const hamburgerLine = {
  display: "block",
  width: 18,
  height: 2,
  background: "#0f172a",
  margin: "2px 0",
  borderRadius: 2,
};
